/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../model/types.tsx';
import { getQuickstartTypeSelector } from '../../model/utils.tsx';
import { getLocalStorageItem } from '../../utils.tsx';

export const syncVisibilityWithLocal =
	(): Action<State> =>
	({ getState, setState }) => {
		const state = getState();
		const quickstartType = getQuickstartTypeSelector(state);
		const visibilityLocal = getLocalStorageItem(`${quickstartType}.visibility`);
		if (visibilityLocal === state.visibility[quickstartType]) {
			return;
		}
		setState({
			visibility: {
				...state.visibility,
				[quickstartType]: visibilityLocal,
			},
		});
	};
